import * as Yup from "yup";
import i18n from "../i18n";

export const VisitPurposeSchema = Yup.object({
  purposeEn: Yup.string().required(
    i18n.language === "en"
      ? "Purpose (English) is required"
      : "الغرض (بالإنجليزية) مطلوب"
  ),
  purposerAr: Yup.string().required(
    i18n.language === "en"
      ? "Purpose (Arabic) is required"
      : "الغرض (بالعربية) مطلوب"
  ),
  visitorType: Yup.string()
  // .required(
  //   i18n.language === "en" ? "Visitor type is required" : "نوع الزائر مطلوب"
  // ),
});
